import script from "./exWarehouse.vue?vue&type=script&setup=true&lang=ts"
export * from "./exWarehouse.vue?vue&type=script&setup=true&lang=ts"

import "./exWarehouse.vue?vue&type=style&index=0&id=e63c7d40&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e63c7d40"]])

export default __exports__